module.exports = __webpack_public_path__ + "static/xp_xpeed_background-f10bb8a213fdf1f3200548bdf82c8f5d.jpg";